__turbopack_context__.v({
  "className": "great_vibes_48b05f09-module__nweyQG__className",
  "variable": "great_vibes_48b05f09-module__nweyQG__variable",
});
